import { Component, ChangeDetectionStrategy } from "@angular/core";

export interface InvitationInvalidDialogData {}

export interface InvitationInvalidDialogResult {}

@Component({
  selector: "app-invitation-invalid-dialog",
  templateUrl: "./invitation-invalid-dialog.component.html",
  styleUrls: ["./invitation-invalid-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InvitationInvalidDialogComponent {
  constructor() {}
}
